<template>
    <div class="tab-pane"  :class="{'active' : user_type =='2'}" id="admit_students_by_deo" aria-labelledby="admit-students-by-deo">
        <div class="form-group row">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <label for="name" class="form-label">Dzongkhag: <span class="text-danger">*</span></label>
                <select v-model="dzongkhag_id" class="form-control" aria-label="dzongkhag_id" :class="{ 'is-invalid': is_invalid }" id="dzongkhag_id" @change="getPublicOrganization">
                    <option v-for="(item, i) in dzongkhags" :key="i" :value="item.id">{{item.name}}</option>
                </select>
                <span v-if="is_invalid">{{error}}</span>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <label for="name" class="form-label">School: <span class="text-danger">*</span></label>
                <select v-model="school_id" class="form-control" aria-label="school_id" :class="{ 'is-invalid': is_invalid }" id="school_id" @change="getStudents(),remove_err('school_id')">
                    <option v-for="(item, i) in schools" :key="i" :value="item.id">{{item.organization}}</option>
                </select>
                <span v-if="is_invalid">{{error}}</span>
            </div>
        </div>
        <div v-show="showTable" class="card">
            <label class="card-header text-center"><strong>The Public Schools Placement Done at School Level</strong></label>
            <table class="table table-bordered table-striped" id="OrgDetails">
                <thead>
                    <tr>
                        <th></th>
                        <th colspan="4" class="text-center">Student Information</th>
                        <th colspan="6" class="text-center">Student Placement</th>
                    </tr>
                    <tr>
                        <th>S.No</th>
                        <th>Name of Student</th>
                        <th>Index Number</th>
                        <th>School</th>
                        <th>Dzongkhag</th>
                        <th>Dzongkhag</th>
                        <th>School</th>
                        <th>Class</th>
                        <th>Stream</th>
                        <th>Remarks</th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in admission_details" :key="index">
                        <td>{{index + 1}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.std_indexno}}</td>
                        <td>{{item.organization}}</td>
                        <td>{{item.dzongkhag}}</td>
                        <td>
                            <select v-if="user_type =='2'" v-model="admission_details[index].class_xi_dzongkhag_id" class="form-control form-control-sm" aria-label="dzongkhags"  :id="'dzongkhag_'+index" @change="getPublicforPlaceOrganization(item.class_xi_dzongkhag_id)">
                                <option  v-for="(item1, i) in cluster_dzongkhags" :key="i" :value="item1.id">{{item1.name}}</option>
                            </select>
                            <select v-if="user_type =='3'" v-model="admission_details[index].class_xi_dzongkhag_id" class="form-control form-control-sm" aria-label="dzongkhags"  :id="'dzongkhag_'+index" @change="getPublicforPlaceOrganization(item.class_xi_dzongkhag_id)">
                                <option  v-for="(item1, i) in dzongkhags" :key="i" :value="item1.id">{{item1.name}}</option>
                            </select>
                        </td>
                        <td>
                            <select v-model="admission_details[index].class_xi_school_id" class="form-control form-control-sm" aria-label="school_id" :id="'school_'+index">
                                <option v-for="(item2, i1) in schools" :key="i1" :value="item2.id">{{item2.organization}}</option>
                            </select>
                        </td>
                        <td>XI</td>
                        <td>
                            <select v-model="admission_details[index].stream" class="form-control form-control-sm" aria-label="stream" :id="'stream_'+index">
                                <option v-for="(item3, i2) in streams" :key="i2" :value="item3.id">{{item3.name}}</option>
                            </select>
                        </td>
                        <td>
                        <select v-model="admission_details[index].remarks" class="form-control form-control-sm" aria-label="status">
                            <option value="admitted">Admitted</option>
                            <option value="not_admitted">Not Admitted</option>
                        </select>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="text-right mb-2 mr-2">
                <button type="button" class="btn btn-primary" @click="submit()"><i class="fas fa-paper-plane"></i>  Submit</button> 
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            showTable:false,
            dzongkhags:[],
            cluster_dzongkhags:[],
            dzongkhag_id:'',
            schools:[],
            school_id:'',
            user_type:'',
              streams: [
                {name:'Science',id:'Science'},
                {name:'Arts',id:'Arts'},
                {name:'Commerce',id:'Commerce'},
                {name:'Rigzhung',id:'Rigzhung'},
            ],
            admission_details:[],
            is_invalid:false,
            error:''
        }
    },
    methods:{
        remove_err(fieldid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
                this.showTable=true;
            }else{
                this.is_invalid = true;
                this.error = "This field is required"
            }
        },
        getDzongkhags(){
                axios.get('dzongkhags/getDzongkhags')
                .then(response =>{ this.dzongkhags = response.data })
                .catch(error => console.log(error));
        },
        getStudents(){
            axios.get('admissions/getStudents/'+this.school_id)
            .then(response =>{ this.admission_details = response.data })
            .catch(error => console.log(error));
        },
     
        getPublicOrganization(){
            this.schools = [];
            axios.get('school/getPublicOrganization/'+this.dzongkhag_id)
            .then(response =>{ this.schools = response.data })
            .catch(error => console.log(error));
            
        }, 
        getPublicforPlaceOrganization(dzongkhag_id){
            this.schools = [];
            axios.get('school/getPublicOrganization/'+dzongkhag_id)
            .then(response =>{ this.schools = response.data })
            .catch(error => console.log(error)); 
        }, 
        getDzongkhagsbyCluster(cluster){
          axios.get('dzongkhags/getDzongkhagsbyCluster/'+cluster)
            .then(response =>{ this.cluster_dzongkhags = response.data })
            .catch(error => console.log(error));
        },
        submit(){
            let filterData = this.admission_details.filter(item => item.remarks == 'admitted')
            axios.post('admissions/saveAdmittedStudents',{data:filterData}).then(res => {
                 if(res.data.error){
                    Swal.fire({
                        icon: 'warning',
                        text: res.data.error,
                    })
                 }else{
                    Toast.fire({
                        icon: 'success',
                        title: 'Detail submitted successfully'
                    })
                this.$router.go(this.$router.currentRoute)
                }
            }).catch(error => console.log(error))
        },
        
        
    },
    mounted(){
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.user_type=data['role'];
            this.getDzongkhagsbyCluster(data['cluster_id'])
        })
        this.getDzongkhags()
    }
    
}
</script>